exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item-bg img{left:0!important;top:0!important;margin-left:0!important;margin-top:0!important}.match-nav-link:not(.active){border:1px solid rgba(0,0,0,.12)!important;margin:2px;border-radius:7px;background:#fff}.match-nav-link.active{border:1px solid #0cc2aa!important;margin:2px;border-radius:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/matches/matchProfile/matchProfile.scss
// module id = 614
// module chunks = 0